<script lang="ts" setup>
    import { ref, computed } from 'vue'

    const props = defineProps({
        lehrsprache: {
            type: String,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: () => false
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() =>
        props.language === 'englisch' ? 'Language of instruction | Lehrsprache' : 'Lehrsprache'
    )

    const emit = defineEmits(['modulLehrspracheSaved'])

    let editLehrsprache = ref('')

    function handleEditStart() {
        editLehrsprache.value = props.lehrsprache
    }

    function handleEditAbort() {
        editLehrsprache.value = ''
    }

    const saveLehrsprache = () => {
        emit('modulLehrspracheSaved', editLehrsprache.value)
    }
</script>

<template>
    <common-single-edit
        :entry="lehrsprache"
        :title="title"
        edit-key="lehrsprache"
        :tool-tip="tooltip"
        :allow-edit="allowEdit"
        @text-saved="saveLehrsprache"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
    >
        <template #edit-component>
            <common-text-field v-model="editLehrsprache" class="w-100 h-100" />
        </template>
    </common-single-edit>
</template>

<script></script>

<style scoped lang="scss"></style>
